import { render, staticRenderFns } from "./y_detail.vue?vue&type=template&id=d3ebb296&scoped=true&"
import script from "./y_detail.vue?vue&type=script&lang=js&"
export * from "./y_detail.vue?vue&type=script&lang=js&"
import style0 from "./y_detail.vue?vue&type=style&index=0&id=d3ebb296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ebb296",
  null
  
)

export default component.exports